import { SpecialistCalendlyLink } from './useCalendlyLinks.interface';

import collectiveApi from 'modules/common/collectiveApi';

export default async function fetchCalendlyLinks(): Promise<SpecialistCalendlyLink[]> {
    const { data } = await collectiveApi.get<SpecialistCalendlyLink[]>('member-calendly-links/');

    return data;
}
